﻿/**
 * Before/after glass-card carousel.
 * Mobile: 1 card; desktop: 2 cards. Native swipe + arrows.
 * Horizontal pan uses CSS touch-action: pan-x pan-y (no preventDefault — that blocks swipe).
 * pan-y is required so the page can still scroll when the finger starts on the track.
 */
(function () {
  'use strict';

  function initBaCarousel(scope) {
    var roots = (scope || document).querySelectorAll('[data-dg-ba]');
    roots.forEach(function (root) {
      if (root.dataset.dgBaReady === 'true') return;

      var viewport = root.querySelector('[data-dg-ba-viewport]');
      var track = root.querySelector('[data-dg-ba-track]');
      var prev = root.querySelector('[data-dg-ba-prev]');
      var next = root.querySelector('[data-dg-ba-next]');
      var buy = root.querySelector('[data-dg-ba-buy]');
      if (!viewport || !track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-dg-ba-card]'));
      if (!cards.length) {
        root.hidden = true;
        return;
      }

      root.dataset.dgBaReady = 'true';
      root.hidden = false;

      var index = 0;

      function visibleCount() {
        return window.matchMedia('(min-width: 960px)').matches ? 2 : 1;
      }

      function cardStep() {
        if (cards.length < 2) return cards[0].offsetWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }

      function maxIndex() {
        return Math.max(0, cards.length - visibleCount());
      }

      function clampIndex(i) {
        return Math.max(0, Math.min(i, maxIndex()));
      }

      function goTo(i, smooth) {
        index = clampIndex(i);
        var step = cardStep();
        viewport.scrollTo({
          left: step * index,
          behavior: smooth === false ? 'auto' : 'smooth'
        });
        updateChrome();
      }

      function updateChrome() {
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex();
      }

      function syncFromScroll() {
        var step = cardStep();
        if (!step) return;
        index = clampIndex(Math.round(viewport.scrollLeft / step));
        updateChrome();
      }

      var scrollTimer;
      viewport.addEventListener(
        'scroll',
        function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(syncFromScroll, 60);
        },
        { passive: true }
      );

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      if (buy) {
        buy.addEventListener('click', function () {
          var atc =
            document.querySelector('.dg-pdp .dg-atc-btn') ||
            document.querySelector('button[name="add"].glow-btn') ||
            document.querySelector('[id^="ProductSubmitButton-"]');
          var hero = document.querySelector('.dg-pdp.hero') || document.querySelector('[id^="MainProduct-"]');
          if (hero) {
            hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          if (atc) {
            window.setTimeout(function () {
              atc.focus({ preventScroll: true });
              atc.click();
            }, 420);
          }
        });
      }

      window.addEventListener(
        'resize',
        function () {
          goTo(index, false);
        },
        { passive: true }
      );

      goTo(0, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBaCarousel();
    });
  } else {
    initBaCarousel();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBaCarousel(event.target);
  });
})();
